import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import dataLayer from '../../../helpers/functions/dataLayer'
import { t } from '../../../../common/i18n'
import Button from '../../buttons/Button'
import SpinnerWithText from '../../spinnerWithText/SpinnerWithText'
import StandardModal from '../standardModal/StandardModal'
import styles from './teLlamamos.module.scss'
import ProteccionDatos from '../../TeLlamamos/ProteccionDatos'
import TeLlamamosForm from '../../TeLlamamos/TeLlamamosForm'

interface Props {
  setOpenModal: (open: boolean) => void
  openModal: boolean
  taller?: string
}

const ModalTeLlamamos = ({ setOpenModal, openModal, taller }: Props) => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    if (openModal) {
      dataLayer.push({
        event: 'callback',
        action: success ? 'conversion' : 'open',
      })
    }
  }, [openModal, success])

  const closeModal = () => {
    setOpenModal(false)
    setLoading(false)
    setSuccess(false)
  }

  return (
    <StandardModal
      closeModal={closeModal}
      showModal={openModal}
      title={t('funnel.te_llamamos_gratis')}
      modalClass={styles.modal_small}>
      {loading && <SpinnerWithText text="Cargando..." />}

      <div className={styles.modal_wrapper_step1}>
        <TeLlamamosForm
          taller={taller}
          setLoading={setLoading}
          setSuccess={setSuccess}
        />
        <ProteccionDatos />
      </div>

      {!loading && success && (
        <div className={styles.modal_wrapper_step2}>
          <div className={styles.yellow_text}>
            <FormattedMessage id="funnel.gracias" />
          </div>
          <div className={styles.process_text}>
            <FormattedMessage id="funnel.contacto" />
          </div>
          <div className={styles.button_wrapper}>
            <Button onClick={() => closeModal()}>
              <FormattedMessage id="funnel.cerrar" />
            </Button>
          </div>
        </div>
      )}
    </StandardModal>
  )
}

export default ModalTeLlamamos
